import script from "./ProfileBirthdayInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileBirthdayInput.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileBirthdayInput.vue?vue&type=style&index=0&id=e5ed438a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ed438a"]])

export default __exports__